import React from 'react';
import { IProduct } from '../../../__core/Interfaces/IProduct';
import { CoursesListItemStyle } from '../Styles/Styles';
import { H2 } from '../../../__core/Styles/Headings/Headings';
import { NavLink } from 'react-router-dom';

type ProductItemProps = { product: IProduct };

const ProductItem: React.FunctionComponent<ProductItemProps> = ({
  product,
}): React.ReactElement => {
  return (
    <CoursesListItemStyle>
      <div className="title-section">
        <H2 as={NavLink} to={`/direct-access/${product.id}`}>
          {product.name}
        </H2>
      </div>
    </CoursesListItemStyle>
  );
};

export default ProductItem;
